import { ManualEventType } from '../codegen/graphql';
import { SYSTEMS_AND_SOLUTIONS_CATEGORY_URN } from '../config/productCategories';

export type NameplateEventAction =
    | ManualEventType.ASSET_ONSITE_INTERVENTION
    | ManualEventType.ASSET_REMOVE
    | null;

/**
 * Picks the event action the column nameplate offers below "Open asset".
 *
 * Assets in the "Systems and solutions" category are serviced on site rather
 * than removed, so when the node allows ASSET_ONSITE_INTERVENTION they get an
 * "On-site Intervention" action instead of "Remove asset" — regardless of
 * whether ASSET_REMOVE is also allowed. Everything else keeps the remove
 * action, gated on ASSET_REMOVE as before.
 */
export const resolveNameplateEventAction = (
    availableEvents: ManualEventType[],
    productCategoryUrn: string | null | undefined,
): NameplateEventAction => {
    if (
        availableEvents.includes(ManualEventType.ASSET_ONSITE_INTERVENTION) &&
        productCategoryUrn === SYSTEMS_AND_SOLUTIONS_CATEGORY_URN
    ) {
        return ManualEventType.ASSET_ONSITE_INTERVENTION;
    }
    if (availableEvents.includes(ManualEventType.ASSET_REMOVE)) {
        return ManualEventType.ASSET_REMOVE;
    }
    return null;
};
